<template>
    <ul class="flow__breadcrumbs">
        <li v-for="breadcrumb in breadcrumbs" class="flow__breadcrumb" v-bind:class="{'flow__breadcrumb--current' :currentStep.BreadcrumbText === breadcrumb}">{{breadcrumb}}</li>
    </ul>
</template>

<script>

    export default {
        name: "flowBreadcrumbs",
        props: ["breadcrumbs","currentStep"]
    };
</script>
